module.exports = __webpack_public_path__ + "TextaNarrow-Heavy-webfont.ffc33d6c6baf54915876.woff";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Heavy-webfont.woff
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Heavy-webfont.woff
// module chunks = styles